import Resource from './Resource';

export default class Device extends Resource{
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let route = !!routeParams.persistentLoginGUID ? `devices/:persistentLoginGUID` : 'devices';
		
		let config = {
			route: route,
			routeParams: routeParams,
			query: query,
			data: data
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}

	delete() {
		return this.request('delete');
	}

}
